import { Component, OnInit } from '@angular/core';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { ModalController, ToastController } from '@ionic/angular';
import { MicroRewardService } from 'src/app/angular-wallet-base/services/micro-reward.service';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
import { Store } from '@ngrx/store';
import { PinModalComponent } from 'src/app/components/pin-modal/pin-modal.component';
import { AUTH_REASON } from 'src/app/angular-wallet-base/constants';
import { take } from 'rxjs/operators';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { openSetPrimaryAddressModal, presentToast } from '../../../../angular-wallet-base/utils';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';

@Component({
  selector: 'app-signature-request',
  templateUrl: './signature-request.component.html',
  styleUrls: ['./signature-request.component.scss'],
})
export class SignatureRequestComponent implements OnInit {
  public isDesktopMode: any;
  public selectedAddress: any;
  private signLoadingValidate;

  constructor(
    private appMode: AppModeService,
    private modalController: ModalController,
    protected store: Store<AppState>,
    private authService: AuthService,
    private microRewardService: MicroRewardService,
    private translate: TranslateService,
    private toast: ToastController,
    private platform: Platform) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
  }

  async ngOnInit() {
    await this.authService.dismissModal('confirmAddressModal');
  }

  ConfirmAddress() {
    this.signLoadingValidate = true;
    this.openPinModal();
  }
  onCancel() {
    this.modalController.dismiss();
  }
  async openPinModal() {
    const modal = await this.modalController.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.USER_ASSOCIATE_ADDRESS
      },
      id: 'pinModal'
    });
    await modal.present();
    await modal.onDidDismiss().then(async res => {
      if (res) {
        const pin = res.data.pin;
        const msg = await this.translate.get('sign_request.sign_message').toPromise();
        await this.signMessageForAssociateAddress(this.selectedAddress, pin, msg);
      }
      this.signLoadingValidate = false;
    });
  }
  async signMessageForAssociateAddress(selectedAddress: any, pin: string, msg: string) {
    switch (selectedAddress.symbol) {
      case 'AVAX':
        const hashValue = await this.microRewardService.signMessageForAvax(selectedAddress.address, msg, pin);
        Logger.info('hashValue', hashValue);
        if (hashValue && selectedAddress) {
          this.signMessageForAvax(selectedAddress, hashValue);
        }
        break;
      default:
        break;
    }
  }
  async signMessageForAvax(selectedAddress, hashValue) {
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    const msg = await this.translate.get('sign_request.sign_message').toPromise();
    const signResponse = await this.microRewardService.postAssociateAddressOfUser(hashValue, selectedAddress.address, 1,
      selectedAddress.name.toLowerCase(), msg);
    Logger.info('signResponse', signResponse);
    if (signResponse.status === 0) {
      await presentToast('sign_request.failed', 'sign_request.failed_des', this.translate, this.toast, this.platform);
      this.onCancel();
    } else {
      await openSetPrimaryAddressModal(sideMenuHidden, this.isDesktopMode, this.modalController, true, this.selectedAddress);
      await this.microRewardService.showAssociateAddressModal(false);
    }
  }
}
